import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import useNotification from 'hooks/useNotification';
import { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import KbGroupsService from 'services/KbGroups.service';

const KbGroupDeletionModal = ({
  show,
  close,
  groupName,
  groupId,
  isSuccess
}) => {
  const { showSuccessNotification, showErrorNotification } = useNotification();

  const [name, setName] = useState('');

  useEffect(() => {
    if (show) {
      setName('');
    }
  }, [show]);

  const handleDelete = async () => {
    const req = await KbGroupsService.delete(groupId);
    if (req.userMessage) {
      showErrorNotification(req.userMessage);
      return;
    }

    showSuccessNotification('Pasta excluída com sucesso');

    // Passar o ID da pasta excluída para o callback
    isSuccess(groupId);
    close();
  };

  return (
    <Modal show={show} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar Exclusão</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning" className="w-100">
          <Flex>
            <div className="border-end border-2 border-warning d-flex align-items-center me-3 pe-3">
              <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
            </div>
            Todas as pastas e artigos presentes neste grupo serão excluídos de
            forma permanente. Lembre-se de que esta ação é irreversível!
          </Flex>
        </Alert>

        <Form.Group>
          <Form.Label className="mt-3">
            Insira o nome do grupo para evitar exclusão acidental.
          </Form.Label>
          <Form.Control
            type="text"
            placeholder={groupName || 'Nome do item'}
            required
            value={name}
            onChange={e => setName(e.target.value)}
            autoFocus
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" onClick={close}>
          Cancelar
        </Button>
        <Button
          variant="danger"
          onClick={() => handleDelete(groupId)}
          disabled={name !== groupName}
        >
          Excluir
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default KbGroupDeletionModal;
